import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  timer: null,
  loaded: false,
  lastUpdate: null,
};

const timesheetTimerSlice = createSlice({
  name: 'timesheetTimer',
  initialState,
  reducers: {
    setTimesheetTimer: (state, action) => {
      state.timer = action.payload || null;
      state.loaded = true;
      state.lastUpdate = new Date().toISOString();
    },
    resetTimesheetTimer: () => initialState,
  },
});

export const {
  setTimesheetTimer,
  resetTimesheetTimer,
} = timesheetTimerSlice.actions;

export const selectTimesheetTimer = (state) => state.timesheetTimer.timer;
export const selectTimesheetTimerLoaded = (state) => state.timesheetTimer.loaded;
export const selectTimesheetTimerLastUpdate = (state) => state.timesheetTimer.lastUpdate;

export default timesheetTimerSlice.reducer;
